import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { RadioField } from '../../../../modules/core/components/form/radio-field/radio-field';
export default angular
    .module('doxy.common.components.form.radio-field', [])
    .component('doxyFormRadioField', {
    //doxy-form-radio-field
    template: `<div"></div>`,
    bindings: {
        options: '<',
        item: '<',
        onChange: '<',
        name: '@',
    },
    controller: function ($element) {
        const render = () => {
            ReactDOM.render(React.createElement(RadioField, {
                options: this.options,
                value: this.item,
                name: this.name,
                onChange: this.onChange,
            }), $element[0]);
        };
        this.$onChanges = render;
    },
}).name;
